export default __webpack_public_path__ + "static/media/About_page_1_1948.267bc929.png";